(function () {
  'use strict';

  angular.module('MktzapApp.Directives')
    .service('NotificationService', NotificationService);

  NotificationService.$inject = ['LangService', 'NotificationFactory'];

  function NotificationService (LangService, NotificationFactory) {
    var notifSet = new NotificationFactory({
	        position: 'bottom-right'
	    });

    var vm = this;

    function setNotificationLang () {
      return new Promise(function (resolve, reject) {
        if (!vm.labels) {
          LangService
            .getPageLabels({ 'page': 'common' })
            .$promise
            .then(function (data) {
              vm.labels = data.lang;
              resolve('success');
            });
        } else {
          resolve('success');
        }
      });
    }
    setNotificationLang().then(function () {});
	    function getMessage (message, data, overwrite_message) {
      if (overwrite_message) {
        message = overwrite_message;
      }
      if (data) {
            	if (data.message) {
                	message = data.message;
        } else if (data.data) {
          if (data.data.message) {
            message = data.data.message;
          }
        }
      }
      return message;
    }

    function showNotification (title, message, autoclose, color) {
      notifSet.addNotification({ title: title, content: message, autoclose: autoclose, color: color });
    }

    this.successHandler = function (data, overwrite_message, time = 6000) {
      setNotificationLang()
        .then(function () {
          var message = getMessage(vm.labels.sucOperation, data, overwrite_message);
          showNotification(vm.labels.success, message, time, 'success');
        });
    }

    this.errorHandler = function (data, overwrite_message, time = 6000) {
      setNotificationLang()
        .then(function () {
	        var message = getMessage(vm.labels.errorTryAgain, data, overwrite_message);
          showNotification(vm.labels.errorOperation, message, time, 'alert');
        });
    }

    this.warningHandler = function (data, overwrite_message, time = 6000) {
      setNotificationLang()
        .then(function () {
	        var message = getMessage(vm.labels.error, data, overwrite_message);
          showNotification(vm.labels.alert, message, time, 'warning');
        });
    }
  }
})();
